import ApplicationQuestionsTranslationMap from "@Client/data/application-questions-translation-map.json";
import i18n from "@Shared/@i18n";
export const useApplicationQuestionsTranslations = currentFlow => {
  const getQuestionTranslationsByFieldPath = path => {
    const question = ApplicationQuestionsTranslationMap[removeIndexIndicator(path)];
    const questionPath = typeof question === "string" ? question : question[currentFlow];
    return {
      "en-CA": i18n.t(questionPath, "en-CA"),
      "fr-CA": i18n.t(questionPath, "fr-CA")
    };
  };
  const removeIndexIndicator = path => {
    return path.replace(/\[[0-9]]/g, "");
  };
  return {
    getQuestionTranslationsByFieldPath
  };
};